// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5178":"905a2509fed79d8c","7815":"cf9c9ad17625d86e"}[chunkId] + ".css";
};